<template>
	<div>统计</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>